export type UserRole = 'admin' | 'trabajador' | 'finanza' | 'logistica';

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Administrador',
  trabajador: 'Trabajador',
  finanza: 'Finanzas',
  logistica: 'Logística',
};
